import { subject } from "@casl/ability";
import { ActionIcon, Group } from "@mantine/core";
import { IconGripVertical } from "@tabler/icons-react";
import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import CategoriaValueRow from "./CategoriaValueRow";
import ContextMenuRow from "./ContextMenuRow";

const columnHelper = createColumnHelper<TGruposDiagnostico>();

const columns: ColumnDef<TGruposDiagnostico>[] = [
  columnHelper.display({
    id: "dragHandle",
    size: 40,
    cell: () => (
      <ActionIcon
        variant="subtle"
        color="gray"
        size="sm"
        style={{ cursor: "grab" }}
        className="drag-handle"
        aria-label="Arrastar para reordenar"
      >
        <IconGripVertical size={16} />
      </ActionIcon>
    )
  }),
  columnHelper.accessor("nome", {
    header: "Nome",
    enableSorting: false,
    enableColumnFilter: true
  }),
  columnHelper.accessor("descricao", {
    header: "Descrição",
    enableSorting: false,
    enableColumnFilter: true
  }),
  columnHelper.accessor("idQuestionario", {
    header: "Questionário",
    enableSorting: false,
    enableColumnFilter: true,
    cell: (properties) => <CategoriaValueRow properties={properties.getValue()} />
  }),
  columnHelper.accessor("pesoNota", {
    header: "Peso Nota",
    enableSorting: false,
    enableColumnFilter: true
  }),
  columnHelper.display({
    id: "actions",
    cell: (properties) => {
      const grupo = subject("TGruposDiagnostico", properties.row.original);

      return (
        <Group justify="center" gap={2}>
          <ContextMenuRow grupo={grupo} />
        </Group>
      );
    }
  })
];

export default columns;
